import React, { useState, useEffect } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import uniLogo from './../../images/uniempleo-logo-nuevo.png';
import { validateEmail } from '../../helpers';
import bnr from '../../images/portada-uniempleo.png';


export function RegisterPage(props) {
	const [email, setEmail] = useState('');
	const [name, setName] = useState('');
	const [lastName, setLastName] = useState('');
	const [companyName, setCompanyName] = useState('');

	let errorsObj = { email: '', password: '', name: '', lastName: '', companyName: '' };
	const [errors, setErrors] = useState(errorsObj);
	const [password, setPassword] = useState('');

	const [userType, setUserType] = useState(null);
	const history = useHistory();
	const location = useLocation();

	// Zustand store
	const { signup, setLoading, errorMessage, successMessage, showLoading } = useAuthStore();

	useEffect(() => {
		// Leer el tipo de usuario desde query params o localStorage
		const queryParams = new URLSearchParams(location.search);
		const typeFromQuery = queryParams.get('type');
		const typeFromStorage = localStorage.getItem('registerUserType');

		const finalType = typeFromQuery || typeFromStorage;

		if (!finalType || (finalType !== 'applicant' && finalType !== 'employer')) {
			// Si no hay tipo válido, redirigir al onboarding
			history.push('/register');
			return;
		}

		setUserType(finalType);
	}, [location.search, history]);

	function onSignUp(e) {
		e.preventDefault();
		let error = false;
		const errorObj = { ...errorsObj };

		if (userType === 'applicant' && name === '') {
			errorObj.name = 'El nombre es requerido';
			error = true;
		}

		if (userType === 'applicant' && lastName === '') {
			errorObj.lastName = 'El apellido es requerido';
			error = true;
		}

		if (email === '') {
			errorObj.email = 'El correo electrónico es requerido';
			error = true;
		} else if (!validateEmail(email)) {
			errorObj.email = 'El correo electrónico es inválido';
			error = true;
		}

		if (password === '') {
			errorObj.password = 'La contraseña es requerida';
			error = true;
		} else if (password.length < 6) {
			errorObj.password = 'La contraseña debe tener al menos 6 caracteres';
			error = true;
		}

		if (!userType) {
			error = true;
		}

		if (userType === 'employer' && companyName === '') {
			errorObj.companyName = 'El nombre de la empresa es requerido';
			error = true;
		}

		setErrors(errorObj);
		if (error) return;

		const profileType = userType === 'applicant' ? 'USUARIO' : 'EMPRESA';
		const razonSocial = userType === 'employer' ? companyName : null;

		setLoading(true);
		signup(email, password, name, lastName, profileType, props.history, razonSocial);
	}

	return (
		<div className="page-wraper">
			<div className="browse-job login-style3">

				<div className="bg-img-fix dez-bnr-inr overlay-black-middle" style={{ backgroundImage: `url(${bnr})`, minHeight: "100vh", backgroundSize: 'cover', backgroundPosition: 'center' }}>
					<div className="row" style={{ minHeight: "100vh" }}>
						<div
							className="col-xl-4 col-lg-5 col-md-6 col-sm-12 bg-white z-index2 relative p-a0 content-scroll skew-section left-bottom"
							style={{
								minHeight: "100%",
								maxHeight: "none",
								overflowY: 'auto',
								scrollbarWidth: 'none', /* Firefox */
								msOverflowStyle: 'none' /* IE and Edge */
							}}
						>
							<style>
								{`
									.content-scroll::-webkit-scrollbar {
										display: none; /* Chrome, Safari, Opera */
									}
								`}
							</style>
							<div className="login-form style-2" style={{ padding: "15px 25px", minHeight: "100vh", display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
								<div>
									<div className="logo-header text-center" style={{ padding: '15px 0' }}>
										<Link to={"./"}><img src={uniLogo} alt="UNIEMPLEO" style={{ maxWidth: '140px' }} /></Link>
									</div>
									<div className="clearfix"></div>
									<div className="tab-content nav tab" style={{ paddingBottom: '15px' }}>
										<div id="login" className="tab-pane active ">

											{errorMessage && (
												<div className='bg-red-100 text-red-700' style={{ padding: '8px 12px', marginBottom: '12px', borderRadius: '4px', border: '1px solid rgba(192, 24, 35, 0.3)', fontSize: '13px' }}>
													{errorMessage}
												</div>
											)}

											{successMessage && (
												<div className='bg-green-100 text-green-700' style={{ padding: '8px 12px', marginBottom: '12px', borderRadius: '4px', border: '1px solid rgba(0, 146, 71, 0.3)', fontSize: '13px' }}>
													{successMessage}
												</div>
											)}
											<form className=" dez-form" style={{ paddingBottom: '5px' }} onSubmit={onSignUp}>
												<h3 className="form-title" style={{ color: '#00004C', fontSize: '1.4rem', fontWeight: '700', marginTop: 0, marginBottom: '8px' }}>
													{userType === 'applicant' ? 'Información del Postulante' : 'Información del Empleador'}
												</h3>

												{userType === 'applicant' ? (
													<p style={{ color: '#666', marginBottom: '18px', fontSize: '13px' }}>Completa tu información personal para crear tu cuenta.</p>
												) : (
													<p style={{ color: '#666', marginBottom: '18px', fontSize: '13px' }}>Completa la información de tu empresa para crear tu cuenta.</p>
												)}

												{userType === 'applicant' && (
													<div>
														<div className="form-group" style={{ marginBottom: '15px' }}>
															<label className="font-weight-600" style={{ marginBottom: '6px', color: '#333', fontSize: '13px', display: 'block' }}>Nombre *</label>
															<input
																value={name}
																onChange={(e) => setName(e.target.value)}
																className="form-control"
																placeholder="Ej: Juan"
																style={{ padding: '10px 12px', fontSize: '13px' }}
															/>
															<div className="text-danger" style={{ fontSize: '12px', marginTop: '4px' }}>{errors.name && <div>{errors.name}</div>}</div>
														</div>

														<div className="form-group" style={{ marginBottom: '15px' }}>
															<label className="font-weight-600" style={{ marginBottom: '6px', color: '#333', fontSize: '13px', display: 'block' }}>Apellido *</label>
															<input
																value={lastName}
																onChange={(e) => setLastName(e.target.value)}
																className="form-control"
																placeholder="Ej: Pérez"
																style={{ padding: '10px 12px', fontSize: '13px' }}
															/>
															<div className="text-danger" style={{ fontSize: '12px', marginTop: '4px' }}>{errors.lastName && <div>{errors.lastName}</div>}</div>
														</div>
													</div>
												)}

												{userType === 'employer' && (
													<div className="form-group" style={{ marginBottom: '15px' }}>
														<label className="font-weight-600" style={{ marginBottom: '6px', color: '#333', fontSize: '13px', display: 'block' }}>Nombre de la Empresa *</label>
														<input
															value={companyName}
															onChange={(e) => setCompanyName(e.target.value)}
															className="form-control"
															placeholder="Ej: Mi Empresa S.A. de C.V."
															style={{ padding: '10px 12px', fontSize: '13px' }}
														/>
														<div className="text-danger" style={{ fontSize: '12px', marginTop: '4px' }}>{errors.companyName && <div>{errors.companyName}</div>}</div>
													</div>
												)}

												<div className="form-group" style={{ marginBottom: '15px' }}>
													<label className="font-weight-600" style={{ marginBottom: '6px', color: '#333', fontSize: '13px', display: 'block' }}>Correo Electrónico *</label>
													<input
														value={email}
														onChange={(e) => setEmail(e.target.value)}
														className="form-control"
														placeholder="correo@ejemplo.com"
														style={{ padding: '10px 12px', fontSize: '13px' }}
													/>
													<div className="text-danger" style={{ fontSize: '12px', marginTop: '4px' }}>{errors.email && <div>{errors.email}</div>}</div>
												</div>
												<div className="form-group" style={{ marginBottom: '15px' }}>
													<label className="font-weight-600" style={{ marginBottom: '6px', color: '#333', fontSize: '13px', display: 'block' }}>Contraseña *</label>
													<input
														value={password}
														type="password"
														className="form-control"
														placeholder="Contraseña"
														onChange={(e) => setPassword(e.target.value)}
														style={{ padding: '10px 12px', fontSize: '13px' }}
													/>
													<div className="text-danger" style={{ fontSize: '12px', marginTop: '4px' }}>{errors.password && <div>{errors.password}</div>}</div>
												</div>

												<div className="form-group" style={{ marginTop: '20px' }}>
													<button
														type="submit"
														className="site-button"
														style={{
															backgroundColor: showLoading ? '#cccccc' : '#009247',
															borderColor: showLoading ? '#cccccc' : '#009247',
															width: '100%',
															padding: '11px 18px',
															fontSize: '15px',
															fontWeight: '600',
															transition: 'all 0.3s ease',
															borderRadius: '4px',
															marginBottom: '10px',
															cursor: showLoading ? 'not-allowed' : 'pointer',
															opacity: showLoading ? 0.6 : 1
														}}
														disabled={showLoading}
													>
														{showLoading ? (
															<>
																<i className="fa fa-spinner fa-spin" style={{ marginRight: '8px' }}></i>
																Registrando...
															</>
														) : 'Registrarme'}
													</button>
													<div className="text-center" style={{ marginTop: '10px' }}>
														<span style={{ color: '#666', fontSize: '13px' }}>¿Ya tienes cuenta? </span>
														<Link
															to={userType === 'employer' ? "/login?as=company" : "/login"}
															style={{
																color: '#00004C',
																fontSize: '13px',
																fontWeight: '600',
																textDecoration: 'none',
																transition: 'color 0.3s ease'
															}}
														>
															Iniciar Sesión
														</Link>
													</div>
												</div>
											</form>
										</div>
									</div>
								</div>

								<div className="bottom-footer clearfix row text-center" style={{ padding: '0px 0 8px', marginTop: '0px', borderTop: '1px solid #e9ecef' }}>
									<div className="col-lg-12 text-center">
										<span style={{ fontSize: '11px', color: '#999' }}>© {new Date().getFullYear()} UNIEMPLEO - Universidad del Caribe. Todos los derechos reservados.</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>
		</div>
	)
}